import { VehicleNotificationType } from './notifications-types';

export const getNotificationTag = (notificationType: VehicleNotificationType) => {
	switch (notificationType) {
		case VehicleNotificationType.PreITV:
			return `ITV`;
		case VehicleNotificationType.Mantenimiento:
			return `Mantenimiento`;
		case VehicleNotificationType.HuchaTaller:
			return `Beneficios`;
		default:
			return '';
	}
};

export const getNotificationMessage = (notificationType: VehicleNotificationType, vgedModelGroup: string) => {
	const vehicleName = vgedModelGroup || 'Volkswagen';
	switch (notificationType) {
		case VehicleNotificationType.PreITV:
			return `Tu ${vehicleName} tiene una cita: la ITV`;
		case VehicleNotificationType.Mantenimiento:
			return `Recuerda que tu ${vehicleName} tiene que pasar por taller `;
		case VehicleNotificationType.HuchaTaller:
			return `Te damos la bienvenida con 50€ para tu próxima visita a taller`;
		default:
			return '';
	}
};
